import React from 'react';
import {
  Outlet, Link,
} from 'react-router-dom';
import { SecondaryAppBar, OutlinedIcons } from '@marageti/z4-lib';
import { IconButton } from '@mui/material';

const View = () => (
  <>
    <SecondaryAppBar
      position="static"
      startAdornment={(
        <IconButton
          edge="start"
          component={Link}
          to="."
        >
          <OutlinedIcons.OutlinedArrowLeftIcon color="primary" />
        </IconButton>
        )}
    />
    <Outlet />
  </>
);

export default View;
